'use client'

import * as React from 'react'
import { ReactElement } from 'react'

export type CustomerSubsciption = {
  email: string
  name?: string
  lastName?: string
  phone?: string
  dninie?: string
}

export function FormPaymentLayout({ children }): ReactElement {
  return (
    <div>
      <div className="flex flex-col bg-white p-4 md:p-8">{children}</div>
    </div>
  )
}
